// eslint-disable-next-line no-shadow
export enum DocumentType {
  BankStatement = 'Bank Statement',
  BalanceStatement = 'Balance Statement',
  PLStatement = 'P&L Statement',
  ARAging = 'AR Aging',
  APAging = 'AP Aging',
}
